/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _parseFloat from "@babel/runtime-corejs3/core-js-stable/parse-float";

/** @module browser/modules/element-utils/get-height */

/**
 * @description Returns passed element's height considering margins.
 * @param {HTMLElement} elem - Element.
 * @returns {number} Element height.
 */
function getHeight(elem) {
  var computedStyle = window.getComputedStyle(elem);

  var marginTop = _parseFloat(computedStyle.marginTop);

  var marginBottom = _parseFloat(computedStyle.marginBottom);

  return elem.getBoundingClientRect().height + marginTop + marginBottom;
}

export { getHeight };